module.exports = __webpack_public_path__ + "media/images/products/retailers-customised-3-bookshop-info-6d851e4df3f52952e09cc0fd5f614565.jpg";